import { DEVICE_ZONE_COOKIE } from '~/composables/useTimeDisplay'
import { deviceZone } from '~/utils/time'

/**
 * 把设备时区（IANA 名）写进 cookie：之后的访问服务端按它渲染 <LocalTime>，
 * 与客户端结果一致，首屏不闪、无水合不一致（规范 6.2 SSR）。
 * 取不到合法 IANA 名时不写，服务端继续只输出占位。
 */
export default defineNuxtPlugin(() => {
  const tz = deviceZone()
  if (!tz) return
  const cookie = useCookie<string | null>(DEVICE_ZONE_COOKIE, {
    path: '/',
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 365,
  })
  if (cookie.value !== tz) cookie.value = tz
})
